import { lazyLoad } from "utils/loadable"

export const RiderPerformancePage = lazyLoad(
  () => import("./index"),
  module => module.RiderPerformancePage,
)
